import { mq } from "helpers/styled"
import styled from "styled-components"
import Item from "./Item"

const Wrapper = styled.div`
  display: none;

  @media ${mq("md")} {
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: minmax(10px, 1fr);
    grid-gap: 25px;
    justify-items: center;
    padding: 0 5px;
  }

  @media ${mq("xl")} {
    padding: 0 15px;
  }
`

export default function Conditions(props) {
  return (
    <Wrapper {...props}>
      <Item icon="pre-delivery">
        Solo <b>1 coche</b> disponible por oferta
      </Item>
      <Item icon="chrono">
        Estudio online en <b>5 minutos</b>
      </Item>
      <Item icon="calendar">
        Pruébalo <b>15 días</b> o 1.000km
      </Item>
      <Item icon="home-delivery">
        Devuélvelo sin coste a los <b>6 meses</b>
      </Item>
      <Item icon="mobile-buy">
        Si te gusta, <b>lo compras</b>
      </Item>
      <Item icon="fast-delivery">
        Entrega
        <br />
        <b>rápida</b>
      </Item>
    </Wrapper>
  )
}
